var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.75,425.36c-4.72-5.57-5.34-14.51-4.65-21.77s2.38-14.58,1.23-21.78c-.68-4.27-2.33-8.35-2.89-12.64s.23-9.13,3.55-11.9c3.82-3.18,9.83-2.43,13.8.56s6.28,7.68,8,12.35c3.69,10.27,5.05,21.66,2,32.15s-10.15,19.86-20.6,23",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.81,438c.77-2.69,2.43-5.29,5-6.39s5.77-.5,8.5.49,5.42,2.33,8.32,2.51,6.19-1.2,7.06-4c.81-2.61-.76-5.39-2.73-7.29a17.21,17.21,0,0,0-28.19,6.77",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.81,438c.77-2.69,2.43-5.29,5-6.39s5.77-.5,8.5.49,5.42,2.33,8.32,2.51,6.19-1.2,7.06-4c.81-2.61-.76-5.39-2.73-7.29a17.21,17.21,0,0,0-28.19,6.77"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M118.8,449.67c-4.26-4-4-11.09-1.92-16.57s6.76-9.68,11.94-12.46a37.82,37.82,0,0,1,33-1.06A15.63,15.63,0,0,0,149.14,427c-2.34,3.88-2.86,8.59-4.79,12.68a19.93,19.93,0,0,1-25.55,10",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.49,471a2.63,2.63,0,0,1,0-.64c0-.42,0-1,0-1.84,0-1.6.2-3.91.55-6.75a88,88,0,0,1,1.8-9.88,45.41,45.41,0,0,1,4.51-11.45,47.69,47.69,0,0,1,15.11-16.28c1.18-.81,2.33-1.42,3.31-2s1.89-1,2.61-1.3l1.7-.71a2.89,2.89,0,0,1,.61-.21,2.89,2.89,0,0,1-.57.31l-1.65.79c-.71.37-1.57.82-2.56,1.37s-2.08,1.22-3.24,2.05a48.88,48.88,0,0,0-14.87,16.22c-4.33,7.57-5.52,15.54-6.39,21.13-.4,2.82-.6,5.12-.72,6.71q-.08,1.13-.12,1.83A3,3,0,0,1,114.49,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.49,409.93c-8.72,5.27-8.7,10.06-7.24,14.59s6.81,7.66,11.26,6c2.51-1,4.32-3.14,5.88-5.33s3-4.54,5.19-6.12,5.33-2.17,7.51-.61",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.49,409.93c-8.72,5.27-8.7,10.06-7.24,14.59s6.81,7.66,11.26,6c2.51-1,4.32-3.14,5.88-5.33s3-4.54,5.19-6.12,5.33-2.17,7.51-.61"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M67,415.71c2.28-3.16,7.92-4.07,11.48-2.5s6.17,4.7,8.5,7.81,4.61,6.41,7.84,8.57,7.75,3,11,.77a9.42,9.42,0,0,0,3.73-6.45,21.48,21.48,0,0,0-.52-7.61c-.77-3.66-2-7.48-4.95-9.81-3.27-2.59-7.8-2.71-12-2.58-4.78.16-9.63.52-14.12,2.18s-9.07,5.23-11,9.62",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.92,470.59a5,5,0,0,1-.06-.75c0-.55,0-1.27-.09-2.17-.06-1.94-.14-4.64-.25-8s-.25-7.37-.5-11.81-.58-9.31-1.25-14.39a47.16,47.16,0,0,0-1.45-7.3,37.21,37.21,0,0,0-2.66-6.39,34.62,34.62,0,0,0-7-9.34A27.29,27.29,0,0,0,87.11,406a20,20,0,0,0-2-.87,3.12,3.12,0,0,1-.69-.31,6.86,6.86,0,0,1,.73.21,18.3,18.3,0,0,1,2,.78,26.14,26.14,0,0,1,6.67,4.38,34.33,34.33,0,0,1,7.21,9.38,37.31,37.31,0,0,1,2.73,6.46,46,46,0,0,1,1.47,7.39c.68,5.1,1,10,1.22,14.44s.33,8.45.39,11.82.08,6.09.08,8c0,.9,0,1.62,0,2.17A3.13,3.13,0,0,1,106.92,470.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,470.59s0-.08-.09-.24l-.23-.73c-.2-.65-.43-1.61-.68-2.87a49.29,49.29,0,0,1-.68-10.8,65.26,65.26,0,0,1,2.62-15.84c1.75-5.79,4.24-12,6.44-18.55a81.29,81.29,0,0,0,4.07-19.11,129.44,129.44,0,0,0,.37-16c-.14-4.56-.37-8.25-.52-10.8-.07-1.24-.12-2.22-.16-2.93,0-.31,0-.57,0-.77a1,1,0,0,1,0-.26,1.11,1.11,0,0,1,0,.26c0,.2,0,.45.09.76.06.71.15,1.69.25,2.93.21,2.54.5,6.23.69,10.79a126.54,126.54,0,0,1-.26,16.05,80.56,80.56,0,0,1-4.06,19.23c-2.2,6.62-4.7,12.78-6.47,18.54A66.51,66.51,0,0,0,109.5,456a51.66,51.66,0,0,0,.51,10.75c.22,1.25.41,2.22.58,2.87.07.3.13.55.18.74A1.27,1.27,0,0,1,110.81,470.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fence--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 439.81,
    y: 311.33,
    width: 8.67,
    height: 159.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.91,305.88a8.74,8.74,0,1,1-8.74-8.74A8.73,8.73,0,0,1,452.91,305.88Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 612.09,
    y: 311.33,
    width: 8.67,
    height: 159.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.18,305.88a8.74,8.74,0,1,1-8.73-8.74A8.73,8.73,0,0,1,625.18,305.88Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.07,
    y: 326.71,
    width: 222.11,
    height: 39.74,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.2 326.71 439.81 327.37 416.99 366.45 415.06 366.45 415.06 326.71 440.2 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.34 326.71 473.11 366.45 442.76 366.45 451.99 350.66 465.99 326.71 496.34 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.45 326.71 529.23 366.45 498.88 366.45 522.1 326.71 552.45 326.71",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.57 326.72 585.33 366.45 554.99 366.45 578.22 326.72 608.57 326.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.17 326.72 637.17 366.45 611.11 366.45 634.34 326.72 637.17 326.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.07,
    y: 388.1,
    width: 222.11,
    height: 39.74,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.2 388.1 439.81 388.76 416.99 427.84 415.06 427.84 415.06 388.1 440.2 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.34 388.1 473.11 427.84 442.76 427.84 451.99 412.06 465.99 388.1 496.34 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "552.45 388.1 529.23 427.84 498.88 427.84 522.1 388.1 552.45 388.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "608.57 388.11 585.33 427.84 554.99 427.84 578.22 388.11 608.57 388.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "637.17 388.11 637.17 427.84 611.11 427.84 634.34 388.11 637.17 388.11",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.17,366.45s0-.24,0-.69,0-1.12,0-2c0-1.77,0-4.36-.06-7.73,0-6.76-.07-16.67-.13-29.34l.23.23-222.09.21h0l.43-.44v39.74l-.43-.44,158.12.2,46.88.12,12.67.06,3.29,0,1.14,0s-.35,0-1.08,0l-3.24,0-12.57.05-46.79.13-158.42.19h-.44V326.27h.45l222.09.21h.23v.23c0,12.73-.1,22.68-.13,29.48q0,5,0,7.67c0,.84,0,1.49,0,1.95S637.17,366.45,637.17,366.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.17,427.84s0-.24,0-.68,0-1.13,0-2c0-1.77,0-4.35-.06-7.73,0-6.76-.07-16.66-.13-29.34l.23.23-222.09.21h0l.43-.44v39.74l-.43-.43,158.12.19,46.88.13,12.67,0,3.29,0,1.14,0s-.35,0-1.08,0l-3.24,0-12.57.06-46.79.12-158.42.2h-.44V387.66h.45l222.09.21h.23v.23c0,12.74-.1,22.68-.13,29.48q0,5,0,7.67c0,.84,0,1.49,0,1.95S637.17,427.84,637.17,427.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.78,470.7c0,.14-140.5.26-313.76.26s-313.8-.12-313.8-.26,140.47-.26,313.8-.26S687.78,470.55,687.78,470.7Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.26,
    y: 227.91,
    width: 9.1,
    height: 242.79,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.36,470.7s0-.44,0-1.26,0-2.07,0-3.67c0-3.23,0-8,0-14.09,0-12.23,0-29.93-.08-51.85,0-43.81-.07-104.47-.11-171.92l.26.26h-9.1l.26-.26c-.1,117-.18,215.29-.2,242.79l-.06-.07,6.87,0c1.5,0,2.23,0,2.23,0l-2.19,0-6.91,0h-.07v-.06c0-27.5-.1-125.8-.19-242.79v-.26h9.62v.26c0,67.53-.08,128.26-.11,172.11,0,21.9-.06,39.57-.08,51.79,0,6.09,0,10.81,0,14,0,1.59,0,2.8,0,3.63S158.36,470.7,158.36,470.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.81,
    cy: 185.08,
    r: 52.94,
    transform: "translate(-62 78.59) rotate(-24.01)",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,183.09a3.87,3.87,0,0,1-.09-.77c0-.55-.09-1.3-.16-2.26,0-.5-.07-1.06-.1-1.67s-.2-1.27-.31-2a33.59,33.59,0,0,0-1-4.91,45,45,0,0,0-5.29-12.61,47.38,47.38,0,0,0-12.06-13.42,46.84,46.84,0,0,0-19.91-8.81,47.48,47.48,0,0,0-24.81,2.07,49.91,49.91,0,0,0-6.16,2.71c-1,.54-1.95,1.17-2.94,1.76a24.73,24.73,0,0,0-2.84,2,53.42,53.42,0,0,0-5.36,4.56,51.94,51.94,0,0,0-4.62,5.47,45.78,45.78,0,0,0-6.75,13,46.87,46.87,0,0,0,0,29.79,45.88,45.88,0,0,0,6.74,13,53.18,53.18,0,0,0,4.63,5.48,54.55,54.55,0,0,0,5.35,4.55,24.55,24.55,0,0,0,2.85,2c1,.58,1.95,1.21,2.94,1.75a47.44,47.44,0,0,0,62.94-17.44,45.29,45.29,0,0,0,5.29-12.61,33.86,33.86,0,0,0,1-4.91c.11-.72.24-1.38.31-2s.07-1.16.1-1.66c.07-1,.12-1.71.16-2.26a3.87,3.87,0,0,1,.09-.77,5,5,0,0,1,0,.77c0,.55,0,1.31-.06,2.27,0,.5,0,1.06-.07,1.67s-.17,1.28-.26,2a34.77,34.77,0,0,1-.93,4.95,44.94,44.94,0,0,1-5.2,12.79,47.86,47.86,0,0,1-32.27,22.71,48.14,48.14,0,0,1-25.24-2,49.5,49.5,0,0,1-6.27-2.75c-1-.55-2-1.19-3-1.78a23.84,23.84,0,0,1-2.91-2,44,44,0,0,1-10.18-10.2,46.52,46.52,0,0,1-6.89-13.25,47.61,47.61,0,0,1,0-30.36,46.83,46.83,0,0,1,6.88-13.24,55.07,55.07,0,0,1,4.72-5.57,54,54,0,0,1,5.47-4.63,24.44,24.44,0,0,1,2.9-2c1-.6,2-1.24,3-1.79a51.57,51.57,0,0,1,6.27-2.74,48,48,0,0,1,25.24-2,48,48,0,0,1,32.27,22.71,45.17,45.17,0,0,1,5.2,12.79,34.62,34.62,0,0,1,.93,5c.09.72.21,1.39.26,2s0,1.17.07,1.67c0,1,0,1.72.06,2.28A5,5,0,0,1,201.46,183.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.25,
    y: 177.12,
    width: 55.13,
    height: 11.5,
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-403--inject-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.83,
    y: 58.62,
    width: 207.59,
    height: 207.59,
    transform: "translate(-12.8 49.32) rotate(-5.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.6,256.15s0-.33-.11-1-.16-1.6-.28-2.86c-.24-2.52-.6-6.24-1.07-11.09-.92-9.7-2.27-23.92-4-42-3.4-36.16-8.26-87.79-14.09-149.73l.32.26L411.71,69h0l.3-.36,19.2,206.7-.32-.26,149.77-13.79,42-3.84,11.1-1,2.85-.25,1-.07-.94.1-2.82.28-11,1.06-42,4L430.93,275.68l-.29,0,0-.29c-5.6-60.08-12.22-131-19.28-206.7l0-.33.33,0h0l206.68-19.2.29,0,0,.29c5.71,62,10.47,113.74,13.81,150,1.65,18.07,2.94,32.27,3.83,42,.43,4.83.77,8.53,1,11,.11,1.24.19,2.18.25,2.82S637.6,256.15,637.6,256.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.71,
    y: 54.97,
    width: 9.11,
    height: 22.12,
    transform: "translate(-4.28 39.8) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.97,
    y: 261.82,
    width: 9.11,
    height: 22.12,
    transform: "translate(-23.37 42.46) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.74,
    y: 38.12,
    width: 9.11,
    height: 22.12,
    transform: "translate(-1.94 56.49) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.12,
    y: 246.37,
    width: 9.11,
    height: 22.12,
    transform: "translate(-21.16 59.2) rotate(-5.32)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 520.83,
    cy: 121.58,
    r: 45.4,
    transform: "translate(99.74 451.32) rotate(-51.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.79,167.63a46,46,0,1,1,45.89-50.32h0a46.11,46.11,0,0,1-41.58,50.12C523.65,167.56,522.22,167.63,520.79,167.63Zm.07-90.82c-1.38,0-2.78.07-4.18.2a44.68,44.68,0,1,0,4.18-.2Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.93,116.35a3.19,3.19,0,0,0-5.13-.26,11.06,11.06,0,0,0-1.4,3.13c-.89,2.75-1.67,5.53-2.54,8.29-.09.29-.44.51-.67.76-.19-.28-.5-.55-.54-.86-.22-1.57-.4-3.15-.54-4.73-.29-3.11-.54-6.22-.82-9.32-.48-5.22-1-10.45-1.49-15.66a3.22,3.22,0,0,0-.69-1.62,3.06,3.06,0,0,0-3.53-.63,2.89,2.89,0,0,0-1.56,3q.76,8.31,1.54,16.61a2.32,2.32,0,0,1,0,.78c-.07.21-.31.48-.5.5a.81.81,0,0,1-.57-.4,2.09,2.09,0,0,1-.12-.76l-1.8-19.3a10,10,0,0,0-.14-1.21,2.25,2.25,0,0,0-2-1.94,3,3,0,0,0-3.73,3.46q.87,9.51,1.77,19a5.31,5.31,0,0,1,0,1.12.71.71,0,0,1-.45.5.74.74,0,0,1-.58-.36,3.45,3.45,0,0,1-.16-1c-.48-5.08-.93-10.15-1.43-15.23a2.92,2.92,0,0,0-5.81.56q.74,8.1,1.5,16.18a3.45,3.45,0,0,1,.06,1,3.34,3.34,0,0,1-.47.81c-.23-.24-.64-.46-.67-.72-.22-1.95-.36-3.92-.54-5.88s-.36-4.16-.59-6.23a2.74,2.74,0,0,0-3.25-2.39,2.53,2.53,0,0,0-2.34,2.88q.4,6.1.79,12.22h0c.23,2.48.43,5,.55,7.45a37.64,37.64,0,0,0,3.28,14.37,13.36,13.36,0,0,0,10,7.89,19.33,19.33,0,0,0,14.12-2.84,13,13,0,0,0,6-7.73c1.65-6.29,3.17-12.61,4.67-18.93A3.65,3.65,0,0,0,541.93,116.35Z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477,235.61l.13,1.47-8.61.8L467.45,226l8.38-.78.14,1.47-6.68.63.33,3.64,6-.55.13,1.44-5.95.56.36,3.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.67,227.32l.15,1.58-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.84-9,1.57-.15.14,1.51A3.44,3.44,0,0,1,483.67,227.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.5,226.69l.15,1.57-.37,0c-1.75.17-2.74,1.34-2.55,3.3l.41,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.43,3.43,0,0,1,490.5,226.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,231.17a4.7,4.7,0,1,1,5.11,4.16A4.5,4.5,0,0,1,492,231.17Zm7.71-.72A3,3,0,1,0,497,233.9,3,3,0,0,0,499.72,230.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,225.06l.15,1.57-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.41,3.41,0,0,1,508,225.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.51,222.93l.39,4.14,6-.55L523,228l-6,.56.45,4.8-1.7.16-1.1-11.88,8.38-.78.14,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.78,228.12a4.69,4.69,0,1,1,5.11,4.16A4.49,4.49,0,0,1,524.78,228.12Zm7.7-.72a3,3,0,1,0-2.73,3.45A3,3,0,0,0,532.48,227.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.78,222l.15,1.57-.38,0c-1.74.16-2.73,1.33-2.55,3.3l.42,4.48-1.63.15-.83-9,1.56-.14.14,1.51A3.43,3.43,0,0,1,540.78,222Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.52,225.53a4.39,4.39,0,0,1-4.12,5,3.8,3.8,0,0,1-3.35-1.22l.14,1.42-1.57.15-1.17-12.59,1.63-.15.46,5a3.85,3.85,0,0,1,3-1.73A4.38,4.38,0,0,1,552.52,225.53Zm-1.65.16a3,3,0,1,0-2.74,3.45A3,3,0,0,0,550.87,225.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.81,218.07a1.07,1.07,0,0,1,1-1.17,1.06,1.06,0,0,1,1.2.93,1.07,1.07,0,0,1-1,1.19A1.05,1.05,0,0,1,553.81,218.07Zm.54,2.76,1.63-.15.84,9-1.63.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.23,216l1.17,12.59-1.56.14-.13-1.42a3.82,3.82,0,0,1-3.06,1.83,4.61,4.61,0,0,1-.86-9.18,3.82,3.82,0,0,1,3.27,1.15l-.46-5Zm-.86,8.24a3,3,0,1,0-2.72,3.46A3,3,0,0,0,566.37,224.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.79,214.93,580,227.51l-1.56.15-.13-1.43a3.82,3.82,0,0,1-3.07,1.83,4.61,4.61,0,0,1-.85-9.18,3.83,3.83,0,0,1,3.27,1.15l-.46-4.95Zm-.85,8.24a3,3,0,1,0-2.73,3.45A3,3,0,0,0,577.94,223.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.77,222.52l-7.29.68a3,3,0,0,0,3.5,2.32,3.37,3.37,0,0,0,2.5-1.32l1,1a4.92,4.92,0,0,1-8.67-2.36,4.42,4.42,0,0,1,4.09-5,4.35,4.35,0,0,1,4.87,4.21A2.77,2.77,0,0,1,590.77,222.52Zm-7.4-.49,5.77-.54a2.92,2.92,0,0,0-5.77.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.48,220.29l.48,5.17-1.63.16-.46-5c-.17-1.76-1.13-2.55-2.67-2.4a2.68,2.68,0,0,0-2.57,3.25l.43,4.63-1.63.15-.84-9,1.56-.15.13,1.36a3.86,3.86,0,0,1,3.11-1.74C599.57,216.53,601.23,217.65,601.48,220.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.2,206.21l-6.69.62.8,8.59-6.81.64-.8-8.59L474,209.4l-.46-4.87,16.37-26.09,7.51-.7L482,202.66l12.37-1.16-.71-7.61,6.59-.62.71,7.62,6.7-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.21,195.61c-1.15-12.42,5-20.08,14-20.91s16.48,5.55,17.64,18-5,20.08-14,20.92S511.37,208,510.21,195.61Zm24.53-2.28c-.85-9.13-4.81-13-10-12.53s-8.31,5-7.46,14.16,4.81,13,9.94,12.53S535.59,202.46,534.74,193.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.58,197.34c.59,6.38-3.7,12.34-13.86,13.28-5.34.5-10.84-.62-14.61-3.05l2.52-5.74a17.73,17.73,0,0,0,11.42,2.7c5-.47,7.79-3,7.46-6.47s-3-5.39-8.73-4.86l-3.46.32-.45-4.8,7.64-11-17.18,1.6-.55-5.89,25.77-2.4.44,4.7-8.17,11.77C569,187.74,573.05,191.67,573.58,197.34Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.02a4f44de5d378426893f9a4b85d29da.svg";
export { ForwardRef as ReactComponent };